import React, { useState } from 'react';
import { createContactFormMessage } from '../../utils/contactFormMessageApi';

const Result = () => {
    return (
        <p className="success-message">Your Message has been successfully sent. Our team will contact you soon.</p>
    )
}

function ContactForm({ formStyle }) {
    const [result, showresult] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const sendEmail = async (e) => {
        e.preventDefault();
        if (submitting) return;

        const pageInfo = typeof window !== 'undefined' ? window.location.href : '';
        const payload = {
            fullname: e.target.fullname.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            message_subject: e.target.subject.value,
            message: e.target.message.value,
            page_info: pageInfo,
            ext_info: JSON.stringify({ source_form: 'contact_form' }),
        };

        setSubmitting(true);
        try {
            const res = await createContactFormMessage(payload);
            if (res.ok) {
                e.target.reset();
                showresult(true);
                setTimeout(() => showresult(false), 5000);
                return;
            }
            alert(res.message || '提交失败，请稍后重试');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
            <div className="form-group">
                <input
                    type="text"
                    name="fullname"
                    placeholder="Your Name"
                    required
                />
            </div>

            <div className="form-group">
                <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                />
            </div>

            <div className="form-group">
                <input
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    required
                />
            </div>


            <div className="form-group">
                <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                />
            </div>

            <div className="form-group">
                <textarea
                    name="message"
                    placeholder="Your Message"
                    required
                >
                </textarea>
            </div>

            <input type="hidden" name="page_info" value={typeof window !== 'undefined' ? window.location.href : ''} />

            <div className="form-group">
                <button 
                    className="btn-default btn-large" 
                    type="submit"
                    disabled={submitting}
                    style={{ 
                        background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)',
                        color: '#000'
                    }}
                >{submitting ? 'Submitting...' : 'Submit Now'}</button>
            </div>

            <div className="form-group">
                {result ? <Result /> : null}
            </div>
        </form>
    )
}
export default ContactForm;
